import { Component, OnInit } from '@angular/core';
import { AuthService } from '../providers/auth.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(public authService: AuthService) {
    // console.log('home constructor: ' + authService.displayName);
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/www/html/mediate/src/app/home/home.component.ts